export const store_setting = [
    {
        sub_domain:"",
        delivery_type:["E-CARD","MAIL"]
    }
]